// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".traceability{height:100%;font-family:\"Exo 2\",sans-serif !important}", "",{"version":3,"sources":["webpack://./src/components/Traceability/Traceability.vue"],"names":[],"mappings":"AACA,cACE,WAAA,CACA,yCAAA","sourcesContent":["\n.traceability {\n  height: 100%;\n  font-family: 'Exo 2', sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
